import React from 'react'
import { observer } from 'mobx-react-lite'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import { CustomTableRow } from './CustomTableRow'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'

export const CustomTableBody = observer(<RowData extends AnyObject, RowStore>() => {
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()
   useCustomTableRenderLog('CustomTableBody')

   return (
      <>
         {customTableStore.rows.map((row, index) => {
            return <CustomTableRow key={row.tableRowId} localRow={row} rowIndex={index} />
         })}
      </>
   )
})
